/* src/app/ship/ship-billing-details/ship-billing-details.component.scss */
.ship-billing-details {
  width: 100%;
}
.ship-billing-details .form-section-header {
  margin-bottom: 0 !important;
}
.ship-billing-details .mat-mdc-radio-button {
  display: block;
}
.ship-billing-details .bill-to-third-party {
  padding: 1em 0 0 2.4em;
}
.ship-billing-details .bill-duties {
  padding-top: 2em;
}
.ship-billing-details .customer-bill-to-accounts {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.ship-billing-details .customer-bill-to-accounts .select-wrapper {
  margin-left: 1em;
}
/*# sourceMappingURL=ship-billing-details.component.css.map */
